import take from "lodash/take";

import { max } from "~/tools/max";

import type { TimeRange } from "../../../app/state/view/timeline/TimeRange";
import { useEventPerspectiveProps } from "../../../bottom_content/view/event-perspective/useEventPerspectiveProps";
import type { EventCategory } from "../../../common/openapi";
import { queryEventAttribute } from "../../../queries";
import { type UseQueryResult, useQuery } from "../../../queries/react-query";

export const MAX_DISPLAY_EVENT_TYPES = 7;

export interface UseQueryEventTypesInBucketParams {
	topologyQuery?: string;
	eventCategories?: Array<EventCategory>;
	timeRange: TimeRange;
}

export interface UseQueryEventTypesInBucketResult {
	types: Array<string>;
	overflow: number;
}

export const useQueryEventTypesInBucket = ({
	topologyQuery,
	eventCategories,
	timeRange,
}: UseQueryEventTypesInBucketParams): UseQueryResult<UseQueryEventTypesInBucketResult, Error> => {
	const {
		selectedTimestamp,
		topologyQuery: defaultTopologyQuery,
		eventTypes,
		eventTags,
		eventCategories: defaultEventCategories,
		eventSources,
	} = useEventPerspectiveProps();

	return useQuery({
		keepPreviousData: true,
		select: ({ items }) => ({
			types: take(items, MAX_DISPLAY_EVENT_TYPES),
			overflow: max(0, items.length - MAX_DISPLAY_EVENT_TYPES),
		}),

		...queryEventAttribute("types", {
			timeRange,
			topologyQuery: topologyQuery ?? defaultTopologyQuery,
			playHeadTimestampMs: selectedTimestamp,
			eventTypes,
			eventTags,
			eventCategories: eventCategories ?? defaultEventCategories,
			eventSources,
			limit: MAX_DISPLAY_EVENT_TYPES + 100, // above 100 we simply say 99+
		}),
	});
};
